import ngRedux from "ng-redux";

import env from "@gtmhub/env/module";
import { MessagingService } from "./messagingService";

// TODO: this module uses services from other (potential) modules too:
// AccountResolverService, PlanningSessionsActions, AssigneeActions
const mod = angular.module("sockets", [ngRedux, env]);
mod.service("MessagingService", MessagingService);

export default mod.name;
